"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

var clsx_1 = __importDefault(require("clsx"));

var withStyles_1 = require("../styles/withStyles");

var createStyles_1 = require("../styles/createStyles");

var Typography_1 = __importDefault(require("../Typography"));

var styles = function styles(_ref) {
  var _indicatorTruncate, _indicatorTruncateCur, _indicatorTruncateLas, _textTruncate, _labelTruncate, _labelTruncateCurrent, _labelTruncateCurrent2;

  var breakpoints = _ref.breakpoints,
      palette = _ref.palette,
      spacing = _ref.spacing,
      typography = _ref.typography;
  return createStyles_1.createStyles({
    root: {
      display: 'flex',
      alignItems: 'center'
    },
    indicator: {
      '&::before': {
        counterIncrement: 'stepper',
        content: 'counter(stepper) " "',
        marginRight: spacing(1),
        borderRadius: '50%',
        color: '#fff',
        backgroundColor: palette.text.secondary,
        textAlign: 'center',
        lineHeight: 1.5,
        width: '1.5rem',
        height: '1.5rem',
        display: 'inline-block'
      }
    },
    indicatorActive: {
      '&::before': {
        backgroundColor: palette.primary.main
      }
    },
    indicatorCompleted: {
      '&::before': {
        color: 'transparent',
        backgroundImage: "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath fill='none' stroke='%23fff' stroke-width='3' d='M1.73 12.91l6.37 6.37L22.79 4.59'/%3E%3C/svg%3E\")",
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: '60%'
      }
    },
    indicatorVertical: {
      '&::before': {
        marginRight: 0
      }
    },
    indicatorLabelBottom: {
      '&::before': {
        marginBottom: spacing(1.5)
      }
    },
    indicatorLabelTop: {
      '&::before': {
        marginTop: spacing(1.5)
      }
    },
    indicatorTruncate: (_indicatorTruncate = {}, _indicatorTruncate[breakpoints.down('xs')] = {
      '&::before': {
        margin: '0 !important'
      }
    }, _indicatorTruncate),
    indicatorTruncateCurrent: (_indicatorTruncateCur = {}, _indicatorTruncateCur[breakpoints.down('xs')] = {
      '&::before': {
        transform: 'scale(1.15)',
        fontSize: '0.9em',
        lineHeight: 1.7
      }
    }, _indicatorTruncateCur),
    indicatorTruncateLast: (_indicatorTruncateLas = {}, _indicatorTruncateLas[breakpoints.down('xs')] = {
      '&::before': {
        transform: 'scale(0.9)',
        backgroundColor: 'transparent',
        color: palette.text.secondary,
        width: 'auto',
        paddingLeft: 0
      }
    }, _indicatorTruncateLas),
    text: {
      flexWrap: 'wrap',
      textAlign: 'center'
    },
    textCurrent: {
      fontWeight: 600
    },
    textTruncate: (_textTruncate = {}, _textTruncate[breakpoints.down('xs')] = {
      display: 'none'
    }, _textTruncate),
    labelVertical: {
      flexDirection: 'column',
      justifyContent: 'center'
    },
    labelTop: {
      flexDirection: 'column-reverse'
    },
    labelTruncate: (_labelTruncate = {}, _labelTruncate[breakpoints.down('xs')] = {
      flexDirection: 'row'
    }, _labelTruncate),
    labelTruncateCurrent: (_labelTruncateCurrent = {}, _labelTruncateCurrent[breakpoints.down('xs')] = {
      '&:not(:last-child)': {
        paddingRight: spacing(0.5)
      },
      '&::after': {
        content: '"of"',
        color: palette.text.secondary,
        paddingLeft: spacing(1),
        fontSize: '0.9rem'
      }
    }, _labelTruncateCurrent),
    labelTruncateCurrentLast: (_labelTruncateCurrent2 = {}, _labelTruncateCurrent2[breakpoints.down('xs')] = {
      '&::after': {
        content: '"of " counter(stepper)',
        color: palette.text.secondary,
        paddingLeft: spacing(1),
        fontSize: '0.9rem'
      }
    }, _labelTruncateCurrent2)
  });
};

var StepLabel = React.forwardRef(function (props, ref) {
  var _clsx_1$default, _clsx_1$default2, _clsx_1$default3;

  var _a = props,
      children = _a.children,
      classes = _a.classes,
      current = _a.current,
      completed = _a.completed,
      labelLocation = _a.labelLocation,
      last = _a.last,
      truncate = _a.truncate,
      other = __rest(_a, ["children", "classes", "current", "completed", "labelLocation", "last", "truncate"]);

  var rootClasses = clsx_1.default(classes.root, (_clsx_1$default = {}, _clsx_1$default[classes.labelVertical] = labelLocation !== 'right', _clsx_1$default[classes.labelTop] = labelLocation === 'top', _clsx_1$default[classes.labelTruncate] = truncate, _clsx_1$default[classes.labelTruncateCurrent] = truncate && current, _clsx_1$default[classes.labelTruncateCurrentLast] = truncate && current && last, _clsx_1$default), props.className);
  var textClasses = clsx_1.default(classes.text, (_clsx_1$default2 = {}, _clsx_1$default2[classes.textCurrent] = current, _clsx_1$default2[classes.textTruncate] = truncate, _clsx_1$default2));
  var indicatorClasses = clsx_1.default(classes.indicator, (_clsx_1$default3 = {}, _clsx_1$default3[classes.indicatorActive] = current || completed, _clsx_1$default3[classes.indicatorCompleted] = completed, _clsx_1$default3[classes.indicatorVertical] = labelLocation !== 'right', _clsx_1$default3[classes.indicatorLabelTop] = labelLocation === 'top', _clsx_1$default3[classes.indicatorLabelBottom] = labelLocation === 'bottom', _clsx_1$default3[classes.indicatorTruncate] = truncate, _clsx_1$default3[classes.indicatorTruncateCurrent] = truncate && !last && current, _clsx_1$default3[classes.indicatorTruncateLast] = truncate && !current, _clsx_1$default3));
  var labelTextColor = current || completed ? 'textPrimary' : 'textSecondary';
  var ariaCurrent = current ? 'step' : undefined;
  return React.createElement("div", Object.assign({
    className: rootClasses,
    ref: ref
  }, other), React.createElement("span", {
    className: indicatorClasses
  }), React.createElement(Typography_1.default, {
    variant: "body2",
    component: "span",
    display: "inline",
    color: labelTextColor,
    className: textClasses,
    "aria-current": ariaCurrent
  }, completed && React.createElement(Typography_1.default, {
    variant: "srOnly",
    component: "span"
  }, "Completed:", ' '), children));
});
exports.default = withStyles_1.withStyles(styles, {
  name: 'UnifiStepLabel'
})(StepLabel);